module.exports = __webpack_public_path__ + "img/act2_img_tixian@2x.2025965b.png";